'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

var _Piece = require('./Piece');

var _Piece2 = _interopRequireDefault(_Piece);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cell = function Cell(props) {
  var image = props.image,
      size = props.size,
      level = props.level,
      position = props.position,
      connectDropTarget = props.connectDropTarget,
      isOver = props.isOver;

  var side = size / level;
  var x = position % level * side;
  var y = Math.floor(position / level) * side;

  return connectDropTarget(_react2.default.createElement(
    'div',
    { className: 'piece' },
    _react2.default.createElement(_Piece2.default, {
      position: position,
      image: image,
      size: size,
      side: side,
      x: x,
      y: y,
      isOver: isOver
    }),
    _react2.default.createElement(
      'style',
      null,
      '\n        .piece:hover {\n          opacity: 0.8;\n        }\n      '
    )
  ));
};

var squareTarget = {
  drop: function drop(props, monitor) {
    var item = monitor.getItem();
    var sourcePosition = item.position;
    var dropPosition = props.position;

    props.onSwap(sourcePosition, dropPosition);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

exports.default = (0, _reactDnd.DropTarget)('piece', squareTarget, collect)(Cell);